export enum MODIFY_PASSWORD_FIELDS {
    OLD_PASSWORD = 'password',
    NEW_PASSWORD = 'newPassword',
    CONFIRM_PASSWORD = 'confirmPassword',
}
